<template>
  <NewListItem>
    <template v-slot:image>
      <v-skeleton-loader type="avatar" />
    </template>

    <template v-slot:title>
      <v-skeleton-loader type="text@2" width="80%" />
    </template>

    <template v-slot:meta-columns>
      <div><v-skeleton-loader type="text" width="70%" /></div>
      <div><v-skeleton-loader type="text" width="70%" /></div>
      <div><v-skeleton-loader type="text" width="80%" /></div>
    </template>
  </NewListItem>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import NewListItem from "components/NewListItem.vue"

export default defineComponent({
  name: "NewListItemLoadingSkeleton",
  components: { NewListItem },
})
</script>
